import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchClients } from '../../../../actions/client/clientList'
import Clients from '../../Clients'
import { AppState } from '../../../../reducers'
import { Filters, FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { FilterNumber, FilterStatusClient, FilterVendorName } from '../../../Utils/Filters'
import { ClientListState } from '../../../../reducers/client/clientList'
import { useTranslation } from 'react-i18next'
import { isAdmin, isHeadSales, isManager, isStaff, isVendor, SessionState } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'

interface Props {
  fullInfo?: boolean
  clientList: ClientListState
  session: SessionState
}

const ClientList: React.FC<Props> = ({ clientList, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('client')

  useEffect(() => {
    dispatch(fetchClients(history.location.search))
  }, [dispatch, history.location.search])


  const linkToClientData = (codigo_cliente: number) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/clients/${codigo_cliente}`
    history.push(detailUrl)
  }

  const initClientDefaultFilters: Filters = {
      estado: '1'
  }

  return (
    <div>
      <FiltersBar defaultFilters={initClientDefaultFilters}>
        <FilterNumber style={{ width: '100px' }} name="codigo_cliente" label={t("code")} />
        <FilterTextField style={{ width: '350px', maxWidth: '350px' }} name="nombre" label={t("name")} />
        {/*<FilterTextField style={{ width: '350px', maxWidth: '350px' }} name="nombrefantasia" label={t("fantasyName")} />*/}
        <FilterTextField name="cuit" label={t("documentId")} />
        {(isAdmin(session) || isHeadSales(session) || isStaff(session) || isManager(session) || isVendor(session)) ? <FilterVendorName name="codigo_vendedor" label={t('vendor')} /> : <></>}
        <FilterStatusClient name="estado" label={t("status")} />
      </FiltersBar>
      <Clients
        rows={(clientList.clients || []).map(s => ({ data: s }))}
        loading={clientList.isFetching}
        pagination={clientList.pagination || undefined}
        onClickInfo={linkToClientData}
      />
    </div>
  )
}



const mapStateToProps = (state: AppState) => ({
  clientList: state.clientList,
  session: state.session
})

export default connect(mapStateToProps, null)(ClientList)